export enum StandardCareProposalChannel {
  CREATE = 'standardCareProposal::create',
  EDIT = 'standardCareProposal::patch',
  DELETE = 'standardCareProposal::delete'
}
